(function () {
  var theme = window.ChandraTheme;
  var wrap = document.querySelector('[data-related]');
  if (!theme || !wrap) return;
  var track = wrap.querySelector('[data-related-track]');
  var prev = wrap.querySelector('[data-related-prev]');
  var next = wrap.querySelector('[data-related-next]');
  var bar = wrap.querySelector('[data-related-progress]');
  function step() {
    var card = track.firstElementChild;
    return card ? card.getBoundingClientRect().width + 14 : 220;
  }
  function paint() {
    if (!bar) return;
    var max = track.scrollWidth - track.clientWidth;
    var visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
    var pos = max > 0 ? track.scrollLeft / max : 0;
    bar.style.width = (visible * 100) + '%';
    bar.style.marginLeft = (pos * (1 - visible) * 100) + '%';
  }
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  track.addEventListener('scroll', paint, { passive: true });
  window.addEventListener('resize', paint);
  window.addEventListener('load', paint);
  paint();
})();
